import React from "react";
import styles from "./submit-request-app-bar.module.scss";
import StepIndicator from "../../../../../common/ekedc-components/step-indicator/StepIndicator";
import QuickGuide from "../../../../../common/ekedc-components/quick-guide/QuickGuide";
import { HelpCircleIcon } from "../../../../../assets/icons";

interface SubmitRequestAppBarProps {
	onBack: () => void;
	totalSteps: number;
	activeStep: number;
}

const SubmitRequestAppBar: React.FC<SubmitRequestAppBarProps> = ({ onBack, totalSteps, activeStep }) => {
	return (
		<div className={styles.appBar}>
			<button type="button" className={styles.iconButton} onClick={onBack} aria-label="Go back">
				<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M14.6667 5.5L9.16667 11L14.6667 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</button>

			<div className={styles.indicator}>
				<StepIndicator total={totalSteps} current={activeStep} />
			</div>

			<QuickGuide
				icon={
					<div className={styles.helpIcon}>
						<HelpCircleIcon />
					</div>
				}
				title="Information Title"
				description="Choosing an account type determines how your experience is set up and what features you can access. An individual account is best for personal use, a business account suits teams or companies with higher activity, and an enterprise account supports larger organizations with more advanced needs. Select the option that matches how you plan to use the platform to ensure everything works smoothly from the start."
			/>
		</div>
	);
};

export default SubmitRequestAppBar;
